import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import { Box } from "@mui/material";

import PagePromote from "./PagePromote";
import CertificationsBasecamp from "./CertificationsBasecamp";
import PageSetup from "./PageSetup";
import PageTabs from "../../atoms/PageTabs";

import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const tabs = [
  { value: "get-certified", label: "1. Get Certified" },
  { value: "page-setup", label: "2. Page Setup" },
  { value: "promote", label: "3. Promote" }
];

const tabContent = (setSelectedTab) => ({
  "get-certified": <CertificationsBasecamp setSelectedTab={setSelectedTab} />,
  "page-setup": <PageSetup />,
  promote: <PagePromote />
});

const Badges = () => {
  const { view } = useParams();
  const history = useHistory();
  const { rootPath } = usePlatformLayoutContext();

  const selectedTab = view || "get-certified";
  const setSelectedTab = (v) => history.push(`${rootPath}/badges/${v}`);

  return (
    <Box
      style={{ height: "100%", overflow: "hidden" }}
      display="flex"
      flexDirection="column"
    >
      <PageTabs
        tabs={tabs}
        value={selectedTab}
        onChange={(_, v) => setSelectedTab(v)}
      />
      <Box p={4} flexGrow={1} style={{ overflowY: "auto" }}>
        {tabContent(setSelectedTab)[selectedTab]}
      </Box>
    </Box>
  );
};
export default Badges;
